<template>
  <v-container>
    <v-row dense style="justify-self: end">
      <v-col class="display-flex align-center pa-0" cols="12">
        <v-btn
          color="primary arr"
          style="
            background: linear-gradient(135deg, #2a8b8b, #4cb8b8);
            color: white;
            border-radius: 12px;
            padding: 6px 20px;
            width: fit-content;
          "
          @click="dialog = true"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
            fill="#FFFFFF"
          >
            <path
              d="M160-160v-80h110l-16-14q-52-46-73-105t-21-119q0-111 66.5-197.5T400-790v84q-72 26-116 88.5T240-478q0 45 17 87.5t53 78.5l10 10v-98h80v240H160Zm400-10v-84q72-26 116-88.5T720-482q0-45-17-87.5T650-648l-10-10v98h-80v-240h240v80H690l16 14q49 49 71.5 106.5T800-482q0 111-66.5 197.5T560-170Z"
            />
          </svg>
        </v-btn>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" max-width="800px" scrollable persistent>
      <v-card class="pa-2 pa-sm-4">
        <v-card-title class="d-flex justify-space-between align-center">
          <span class="text-h6">Platforms</span>
          <!-- <v-btn icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn> -->
        </v-card-title>

        <v-divider class="mb-2" />

        <v-card-text>
          <v-row dense>
            <template v-if="Object.keys(platforms).length > 0">
              <v-col
                cols="12"
                v-for="(users, platform) in platforms"
                :key="platform"
              >
                <v-card outlined elevation="0">
                  <v-card-title
                    @click="togglePlatform(platform)"
                    class="d-flex justify-space-between align-center"
                    style="cursor: pointer"
                  >
                    <div class="d-flex ga-4 align-center">
                      <span v-if="platform === 'Facebook'">
                        <img
                          :src="facebookIcon"
                          style="width: 1.9rem; height: 1.9rem"
                          alt="Facebook"
                        />
                      </span>
                      <span v-if="platform === 'Instagram'">
                        <img
                          :src="instagramIcon"
                          style="width: 1.9rem; height: 1.9rem"
                          alt="Instagram"
                        />
                      </span>
                      <span>{{ platform }}</span>
                    </div>
                    <v-icon>
                      {{
                        expandedPlatform === platform
                          ? "mdi-chevron-up"
                          : "mdi-chevron-down"
                      }}
                    </v-icon>
                  </v-card-title>

                  <v-expand-transition>
                    <v-card-text v-if="expandedPlatform === platform">
                      <v-radio-group v-model="selectedUsers">
                        <v-radio
                          v-for="(user, index) in users"
                          :key="index"
                          :value="{ id: user.id, account_id: user.userId }"
                        >
                          <template #label>
                            <div>
                              <strong>{{ user.name }}</strong
                              ><br />
                              <small class="text-grey">{{ user.userId }}</small>
                            </div>
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </v-card-text>
                  </v-expand-transition>
                </v-card>
              </v-col>
              <v-col cols="12" v-if="whats_app_status">
                <div
                  @click="toggleWhatsInfo"
                  class="pl-4 py-2 d-flex align-center justify-space-between"
                  style="cursor: pointer; padding-right: 17px"
                >
                  <p class="d-flex align-center ga-3">
                    <img
                      style="width: 30.39px; height: 30.39px"
                      src="@/assets/images/whatsApp.svg"
                      alt="whatsapp icon"
                    />
                    <span
                      style="
                        font-size: 20px;
                        color: #000000de;
                        font-weight: 500;
                        font-family: Inter, sans-serif;
                      "
                      >Whats App</span
                    >
                  </p>
                  <v-icon
                    size="large"
                    :icon="
                      what_app_info ? 'mdi-chevron-up' : 'mdi-chevron-down'
                    "
                  ></v-icon>
                </div>
                <div v-if="what_app_info" class="whats-app-info">
                  <v-radio-group v-model="selectedUsers.WhatsApp">
                    <v-radio
                      :value="{
                        id: whats_app_data.info.wid,
                        account_id: whats_app_data.info.pushname,
                      }"
                    >
                      <template #label>
                        <div>
                          <strong>{{ what_app_user_info }}</strong
                          ><br />
                          <small class="text-grey">{{
                            what_app_message
                          }}</small>
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </div>
              </v-col>
            </template>
            <template v-else>
              <v-row>
                <v-col cols="12">
                  <v-skeleton-loader
                    v-for="n in 6"
                    :key="n"
                    type="list-item-avatar"
                    class="mx-2 my-1"
                  />
                </v-col>
              </v-row>
            </template>
          </v-row>
        </v-card-text>

        <v-divider class="my-2" />

        <v-card-actions class="justify-end">
          <v-btn
            @click="clearSelection"
            style="
              border: 1px solid #2a8b8b;
              color: #2a8b8b;
              background-color: transparent;
              border-radius: 12px;
              padding: 6px 20px;
              margin-right: 10px;
              font-weight: bold;
              text-transform: capitalize;
            "
          >
            Clear
          </v-btn>
          <v-btn
            @click="getTableData"
            style="
              background: linear-gradient(135deg, #2a8b8b, #4cb8b8);
              color: white;
              border-radius: 12px;
              padding: 6px 20px;
            "
          >
            Done
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import apiClient from "@/core/buildRequest";

// Icons
import facebookIcon from "@/assets/soft-ware-img/facebook-post-select.svg";
import instagramIcon from "@/assets/soft-ware-img/instgrapm.svg";

// State
const dialog = ref(true);
const expandedPlatform = ref(null);
const rawData = ref([]);
const platforms = ref({});
const whats_app_status = ref(false);
const what_app_info = ref(false);
const what_app_user_info = ref("");
const what_app_message = ref("");
const whats_app_data = ref({});
const selectedUsers = ref({
  Facebook: null,
  Instagram: null,
  WhatsApp: null,
});

const toggleWhatsInfo = () => {
  what_app_info.value = !what_app_info.value;
  console.log(what_app_info.value);
};

const emit = defineEmits(["account-selected"]);
const togglePlatform = (platform) => {
  console.log(platform);
  expandedPlatform.value =
    expandedPlatform.value === platform ? null : platform;
};

const clearSelection = () => {
  selectedUsers.value = {
    Facebook: null,
    Instagram: null,
    WhatsApp: null,
  };
  localStorage.removeItem("selectedDmAccounts");
};

const getTableData = () => {
  const selected = selectedUsers.value;

  // ✅ If selected is WhatsApp
  if (selected.WhatsApp?.id && selected.WhatsApp?.account_id) {
    const whatsAppSelected = {
      id: selected.WhatsApp.id,
      account_id: selected.WhatsApp.account_id,
      platform: "WhatsApp", // ✅ مهم جدًا
    };
    emit("account-selected", whatsAppSelected);
    localStorage.setItem(
      "selectedDmAccounts",
      JSON.stringify(whatsAppSelected)
    );
    dialog.value = false;
    return;
  }

  // ✅ Otherwise, handle Facebook/Instagram
  if (selected && selected.id && selected.account_id) {
    const platformKey = Object.keys(platforms.value).find((platform) =>
      platforms.value[platform].some((user) => {
        if (user.id === selected.id && user.userId === selected.account_id) {
          selected.page_id = user.userId;
          return true;
        }
        return false;
      })
    );

    if (platformKey) {
      selected.platform = platformKey;
    }

    emit("account-selected", selected);
    localStorage.setItem("selectedDmAccounts", JSON.stringify(selected));
  }

  dialog.value = false;
};

// Fetch from API
const fetchApiData = async () => {
  try {
    const response = await apiClient.get("/dm/get-dm-pages");
    rawData.value = response.data.data;

    platforms.value = rawData.value.reduce((acc, item) => {
      const provider =
        item.platform === "facebook_messenger"
          ? "Facebook"
          : item.platform === "instagram"
          ? "Instagram"
          : item.platform.charAt(0).toUpperCase() + item.platform.slice(1);

      if (!acc[provider]) acc[provider] = [];

      acc[provider].push({
        id: item.id,
        name: item.account_name,
        userId: item.account_id,
        instagramId: item.instagram_account_id,
      });

      return acc;
    }, {});
  } catch (error) {
    console.error(
      "❌ Failed to fetch DM pages:",
      error.response?.data?.msg || error.message
    );
  }
};

const checkStatus = () => {
  apiClient
    .get("https://promxa.com:3030/whatsapp/status")
    .then((response) => {
      console.log(response.data);
      whats_app_data.value = response.data;
      whats_app_status.value = response.data.connected;
      what_app_user_info.value = response.data.info.pushname;
      what_app_message.value = response.data.message;
    })
    .catch((error) => {
      console.error("Failed to load QR Code:", error);
    });
};

// Restore from localStorage
onMounted(async () => {
  await fetchApiData();
  checkStatus();
  const stored = localStorage.getItem("selectedDmAccounts");
  if (stored) {
    selectedUsers.value = JSON.parse(stored);
  }
});

// Watch whole object and update localStorage with single key
watch(
  selectedUsers,
  (val) => {
    const all = Object.values(val);
    const selected = all.find((v) => v?.id && v?.account_id);
    if (selected) {
      localStorage.setItem("selectedDmAccounts", JSON.stringify(selected));
    }
  },
  { deep: true }
);
</script>

<style scoped>
.v-card-text > .v-input {
  background-color: #f7f7f6;
  border-radius: 0.25rem;
  padding: 1rem;
}
.v-radio-group .v-input__details {
  display: none;
}
.v-container {
  padding: 0;
}
.arr {
  background: linear-gradient(135deg, rgb(42, 139, 139), rgb(76, 184, 184));
  color: white;
  border-radius: 12px;
  padding: 0.3rem;
  height: 3rem;
  font-size: 0.7rem;
  width: 100%;
  margin: 0.7rem 0;
}
.whats-app-info {
  background-color: #f7f7f6;
  padding: 1rem;
  border-radius: 0.25rem;
  margin: 10px 19px;
}
</style>
